import Popup from '../../../dumb/Popup/C';
import TextField from '../../../dumb/TextField/H';
import {
  openPopupWindow,
  openV1PopupInfo,
} from '../../../../emitters/popup';
import React from 'react';
import RefreshIcon from '@material-ui/icons/Refresh';
import withReDelay from 'mn-utils/withReDelay';
import trim from 'mn-utils/trim';
import upperFirst from 'mn-utils/upperFirst';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import formatTime, {getRFC3339} from 'mn-utils/formatTime';
import Ripple from '../../../dumb/Ripple';
import TrashIcon from '../../../icons/Trash';
import SendIcon from '../../../icons/Send';
import Caption from '../../../dumb/Caption/A';
import HeaderA from '../../../dumb/Header/A';
import ButtonUp from '../../../dumb/Button/Up';
import Tooltip from '../../../dumb/Tooltip/A';
import RowA from '../../../dumb/Row/A';
import ColA from '../../../dumb/Col/A';
import ColA2 from '../../../dumb/Col/A2';
import RowB from '../../../dumb/Row/B';
import ColB from '../../../dumb/Col/B';
import ColB2 from '../../../dumb/Col/B2';
import WrapperWithLoading from '../../../dumb/WrapperWithLoading';
import ButtonD from '../../../dumb/Button/D';
import virtualOutputComponentProvider from '../../../../utils/virtualOutputComponentProvider';
import toEllipsisMiddle from '../../../../utils/toEllipsisMiddle';
import formatNumFiat from '../../../../utils/formatNumFiat';
import {
  apiAdminFinerySettlementRemove,
  apiAdminFinerySettlements,
  apiAdminFinerySettlementSend,
} from '../../../../api/admin/finery';
import FieldD from '../../../dumb/Field/D';
import {TableNumberColAmin} from "../../../dumb/TableNumberCol";
const {confirmRemove} = require('../../../../emitters/remove');
const {commit, emit} = require('./emitter');

const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayAmountAdmin,
  DisplayHashAdmin,
  DisplayDateTimeAdmin
} = require("../../../dumb/DisplayData");

const STATUS_CREATED = 'created';
const STATUS_SENDED = 'sended';

const COMPONENT_NAME = 'SettlementTable';
module.exports = virtualOutputComponentProvider({
  rowHeight: 70,
  request: apiAdminFinerySettlements,
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 100);
    commit(COMPONENT_NAME, update);

    const openEditSettlementWindow = (settlement) => {
      openPopupWindow((setPopupState, popup) => {
        const {close} = popup;
        popup.state = {
          clicked: false,
          orderId: settlement.order_id,
          txId: settlement.tx_id,
          fee: settlement.fee,
        };

        const handleProvider = changeProviderProvider(setPopupState);
        const handleChangeTxId = handleProvider('txId');

        return (stateOfPopup) => {
          const {
            orderId,
            txId,
            fee,
          } = stateOfPopup;

          const invalidOrderId = !orderId;
          const invalidTxId = !trim(txId || '');
          const invalidFee = fee < 0;
          const isErrors = invalidOrderId || invalidTxId || invalidFee;

          return (
            <Popup caption={(
              <div className="layoutRow fhaS fvaC w">
                <div>Send Transaction #{orderId}</div>
              </div>
            )}
            text="Send"
            onCancel={close}
            disabled={stateOfPopup.clicked && isErrors}
            onSave={() => {
              if (isErrors) {
                setPopupState({
                  clicked: true,
                });
                return;
              }

              setPopupState({
                loading: true,
              });

              const params = {
                order_id: orderId,
                tx_id: txId,
                ...(fee > 0 ? {fee: fee} : {}),
              };

              apiAdminFinerySettlementSend(params).finally((error) => {
                setPopupState({
                  loading: false,
                });

                if (error) {
                  return;
                }
                emit('SettlementTable');
                emit('PositionTable');
                openV1PopupInfo(['Success', 'Deposit successfully send!']);
                close();
              });
            }}
            >
              <WrapperWithLoading loading={stateOfPopup.loading}>
                <div className="layoutRow fxwWrap mt20 (w1/5)>1">
                  <FieldD
                    label="CP ID"
                    value={settlement.counterparty.id}
                  />
                  <FieldD
                    label="Amount"
                    value={`${settlement.amount ? formatNumFiat(settlement.amount) : 0} ${settlement.asset_code || ''}`}
                  />
                  <FieldD
                    label="Fee"
                    value={`${settlement.fee ? formatNumFiat(settlement.fee) : 0} ${settlement.asset_code || ''}`}
                  />
                </div>
                {settlement.comment && (
                  <div className="mt20">
                    <FieldD
                      label="Comment"
                      value={settlement.comment}
                    />
                  </div>
                )}
                <TextField
                  className="mt30 wmax471 mr10>1"
                  label="Tx ID"
                  value={txId}
                  onChange={handleChangeTxId}
                  error={stateOfPopup.clicked && invalidTxId}
                />
              </WrapperWithLoading>
            </Popup>
          );
        };
      });
    };

    const openRemoveSettlementWindow = (settlement) => {
      confirmRemove(() => {
        setState({
          loading: true,
        });
        const params = {order_id: settlement.order_id};
        apiAdminFinerySettlementRemove(params).finally((error) => {
          setState({
            loading: false,
          });

          if (error) {
            openV1PopupInfo(['Error', 'Deposit is not removed!']);
            return;
          }
          emit('SettlementTable');
          openV1PopupInfo(['Success', 'Deposit is removed!']);
        });
      });
    };

    function Item({data}) {
      const counterparty = data.counterparty || {};
      const counterpartyId = counterparty.id || '';
      const counterpartyName = counterparty.name || '';
      const txId = data.tx_id || '';
      const orderId = data.order_id || '';
      const currency = data.asset_code || '';
      const amount = data.amount || 0;
      const fee = data.fee || 0;
      const comment = data.comment || '';
      const status = data.status || '';
      const date = data.dt || '';

      return (
        <RowA className="f12">
          <ColA className="wmin155 fx1">
            <DisplayIdAdmin>
              {txId}
            </DisplayIdAdmin>
          </ColA>
          <ColA className="wmin155 fx1">
            <DisplayIdAdmin>{orderId}</DisplayIdAdmin>
          </ColA>
          <ColA className="wmin155 fx1">
            <DisplayIdAdmin>{counterpartyId}</DisplayIdAdmin>
          </ColA>
          <ColA className="wmin130 fx1">
            <DisplayDataAdmin>{counterpartyName}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin130 fx1">
            <DisplayAmountAdmin
              amount={amount}
              symbol={currency}
              type="currency"
            />
          </ColA>
          <ColA className="wmin130 fx1">
            <DisplayAmountAdmin
              amount={fee}
              symbol={currency}
              type="currency"
            />
          </ColA>
          <ColA className="wmin130 fx1">
            <DisplayDataAdmin>
              {comment}
            </DisplayDataAdmin>
          </ColA>
          <ColA className="wmin130 fx1">
            <Tooltip title={upperFirst(status)}>
              <span className={'(c8E7CFF).created (cFFBF43).sended (c2CE889).commited (cEE4F4F).cancelled ' + status}>
                {upperFirst(status)}
              </span>
            </Tooltip>
          </ColA>
          <ColA className="wmin95">
            <DisplayDateTimeAdmin date={date} />
          </ColA>
          <ColA2 className="w50 fx1">
            <Tooltip title="Send" disabledCopy>
              {status === STATUS_CREATED && (
                <Ripple
                  className="w40 h40 p7 r7 (bgc0.25):h"
                  onClick={() => {
                    openEditSettlementWindow(data);
                  }}
                >
                  <SendIcon className="w25 h25" />
                </Ripple>
              )}
            </Tooltip>
          </ColA2>
          <ColA2 className="w50 fx1">
            <Tooltip title="Remove" disabledCopy>
              {[STATUS_CREATED, STATUS_SENDED].includes(status) && (
                <Ripple
                  className="w40 h40 p7 r7 (bgc0.25):h"
                  onClick={() => {
                    openRemoveSettlementWindow(data);
                  }}
                >
                  <TrashIcon className="w25 h25"/>
                </Ripple>
              )}
            </Tooltip>
          </ColA2>
        </RowA>
      );
    }

    return (state, props) => {
      return (
        <div className={props.className || ''}>
          <HeaderA>
            <Caption>Deposits</Caption>

            <WrapperWithLoading loading={state.loading}>
              <div className="layoutRow fhaS fvaC">
                <ButtonD
                  className="wmin100"
                  onClick={update}
                >
                  <RefreshIcon/>
                  <div className="pl15">Refresh</div>
                </ButtonD>
              </div>
            </WrapperWithLoading>
          </HeaderA>

          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45">
              <div className="wmin1145 rlv h">
                <RowB className="f12 h66">
                  <ColB className="wmin155 fx1">TX ID</ColB>
                  <ColB className="wmin155 fx1">Order ID</ColB>
                  <ColB className="wmin155 fx1">CP ID</ColB>
                  <ColB className="wmin130 fx1">CP Name</ColB>
                  <ColB className="wmin130 fx1">Amount</ColB>
                  <ColB className="wmin130 fx1">Fee</ColB>
                  <ColB className="wmin130 fx1">Comment</ColB>
                  <ColB className="wmin130 fx1">Status</ColB>
                  <ColB className="wmin95">Date</ColB>
                  <ColB2 className="w50 fx1" />
                  <ColB2 className="w50 fx1" />
                </RowB>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp show={state.showUp} onClick={self.handleToUp}/>
          </div>
        </div>
      );
    };
  },
});
